"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameAction = void 0;
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const irlcg_1 = require("../ontologies/irlcg");
const PlayAction_1 = require("lincd-schema/lib/shapes/PlayAction");
const Topic_1 = require("./Topic");
const xsd_1 = require("lincd-xsd/lib/ontologies/xsd");
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const Team_1 = require("./Team");
let GameAction = class GameAction extends PlayAction_1.PlayAction {
    /**
     * instances of this shape need to have exactly one value defined for the given property
     */
    get topic() {
        return this.getOneAs(irlcg_1.irlcg.topic, Topic_1.Topic);
    }
    set topic(val) {
        this.overwrite(irlcg_1.irlcg.topic, val.namedNode);
    }
    get quantity() {
        return parseInt(this.getValue(irlcg_1.irlcg.quantity));
    }
    set quantity(val) {
        this.overwrite(irlcg_1.irlcg.quantity, new models_1.Literal(val.toString(), xsd_1.xsd.integer));
    }
    get team() {
        return this.getOneAs(irlcg_1.irlcg.team, Team_1.Team);
    }
    set team(val) {
        this.overwrite(irlcg_1.irlcg.team, val.namedNode);
    }
    static submit(topic, actionsAndQuantity, overwritePreviousSubmission = false, subPlayer) {
        return Server_1.Server.call(this, {
            method: 'submit',
            overwriteData: true,
        }, topic, actionsAndQuantity, overwritePreviousSubmission, subPlayer);
    }
    static getGameActionByTopic(topic, player) {
        return Server_1.Server.call(this, 'getGameActionByTopic', topic, player);
    }
    static getAllOf(userAccount) {
        return Server_1.Server.call(this, 'getAllOf', userAccount);
    }
    static hasFinishedGame(userAccount) {
        return Server_1.Server.call(this, 'hasFinishedGame', userAccount);
    }
};
exports.GameAction = GameAction;
/**
 * indicates that instances of this shape need to have this rdf.type
 */
GameAction.targetClass = irlcg_1.irlcg.GameAction;
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: irlcg_1.irlcg.topic,
        shape: Topic_1.Topic,
    }),
    __metadata("design:type", Topic_1.Topic),
    __metadata("design:paramtypes", [Topic_1.Topic])
], GameAction.prototype, "topic", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.quantity,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], GameAction.prototype, "quantity", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: irlcg_1.irlcg.team,
    }),
    __metadata("design:type", Team_1.Team),
    __metadata("design:paramtypes", [Team_1.Team])
], GameAction.prototype, "team", null);
exports.GameAction = GameAction = __decorate([
    package_1.linkedShape
], GameAction);
//# sourceMappingURL=GameAction.js.map